<template>
  <div
    class="item_content accordion_content"
    style="display:block"
  >
    <!-- S : 제품정보 리스트 -->
    <div class="product_list_wrap">
      <div class="summary">
        <strong>{{ packExplain }}</strong>
        <p><em>1일 총 {{ totalPhilsPerDay }}</em> 정/캡슐 <span>(총{{ totalPockets }}포)</span></p>
      </div>
      <div
        v-for="pocket in pocketDetails"
        :key="pocket.dose_seq"
        class="daily_item  width_full_type"
      >
        <p>{{ pocket.takingTime }}</p>
        <ul class="smallImg_list">
          <li
            v-for="item in pocket.items"
            :key="item.item_sku"
          >
            <div class="product_img">
              <a
                :href="item.outlink"
                target="_blank"
              ><img :src="item.img_url"></a>
            </div>
            <div class="product_text_info">
              <p class="product_title">
                <a
                  :href="item.outlink"
                  target="_blank"
                ><span
                   class
                 >{{ item.item_name }}</span> / <template v-if="isDoubleX(item.item_sku)"><span
                   class
                 >{{ item.dose_cnt * 3 }}{{ item.display }} ({{ item.dose_cnt }}세트)</span>
                 </template>
                  <template v-else><span
                    class
                  >{{ item.dose_cnt }}{{ item.display }}</span></template></a>
              </p>
              <div class="hashtag_list">
                <span
                  v-for="(hash, index) in item.hashes"
                  :key="index"
                >#{{ hash }} </span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- E : 제품정보 리스트 -->
  </div>
</template>

<script>
import doubleXMixin from '@/components/global/doublex-mixin';

export default {
  name: 'RecommendItemDetail',
  mixins: [doubleXMixin],
  props: {
    pocketDetails: {
      type: Array,
      default: () => [],
    },
    totalPhilsPerDay: {
      type: Number,
      default: 0,
    },
    totalPockets: {
      type: Number,
      default: 0,
    },
    packExplain: {
      type: String,
      default: '',
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/recommendation/RecommendItemDetail.vue